import type { OAuthLauncher } from '@shootout-comps/core';

// Web OAuth is a fire-and-forget redirect — the page navigates away, and the
// resulting code/error is picked up from the URL query string on next load
// (see App.tsx's getUrlParams/AuthGate handling), not through this promise.
const webOAuthLauncher: OAuthLauncher = {
  launch: (_provider, authUrl) => {
    window.location.href = authUrl;
    return Promise.resolve(null);
  },
};

export default webOAuthLauncher;
